"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore file */
var CtopageState = /** @class */ (function () {
    function CtopageState() {
    }
    return CtopageState;
}());
exports.default = CtopageState;
//# sourceMappingURL=CtopageState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Ctopage/CtopageState.js
// module id = 1136
// module chunks = 8